import React, { useState, useCallback } from "react";
import { ThemeProvider } from "@mui/material";
import { themeCreator } from "./base";
import { StylesProvider } from "@mui/styles";

export const ThemeContext = React.createContext<(themeName: string) => void>(
  () => {}
);

const ThemeProviderWrapper: React.FC<React.PropsWithChildren<{}>> = (props) => {
  const curThemeName = localStorage.getItem("appTheme") || "PureLightTheme";
  const [themeName, setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);
  const changeTheme = useCallback((name: string): void => {
    localStorage.setItem("appTheme", name);
    setThemeName(name);
  }, []);

  return (
    <StylesProvider injectFirst>
      <ThemeContext.Provider value={changeTheme}>
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </ThemeContext.Provider>
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
